// Shared venue metadata for Night Bureau design sandbox.
// Source of truth for slug, color, capacity, address, history, metro.
(function(){
'use strict';

const VENUES_DATA = [
  {
    slug:'l-olympia', aliasSlugs:['olympia'], mood:'olympia', display:'Olympia', prep:"à l'", dbName:"L'Olympia",
    names:["L'Olympia","L Olympia","Olympia"],
    color:'var(--v-olympia)', hex:'#E8562C', tone:'braise', imgY:'30%',
    capacity:1996, type:'Grandes scènes', year:1954, foundYear:1888,
    street:'28 Boulevard des Capucines', postal:'75009', city:'Paris',
    lat:48.8704, lon:2.3282,
    metro:'Opéra · Madeleine',
    tagline:"Le music-hall parisien.",
    history:"Fondé en 1888 par Joseph Oller, l'Olympia est le plus ancien music-hall parisien en activité. Sa façade rouge et ses lettres géantes sont devenues iconiques. Réouvert en 1954 par Bruno Coquatrix, il a accueilli Piaf, Brel, Aznavour, Dylan, Hendrix et continue d'être une étape incontournable des tournées internationales."
  },
  {
    slug:'la-boule-noire', aliasSlugs:['boule'], mood:'boule', display:'Boule Noire', prep:'à la ', dbName:'La Boule Noire',
    names:['La Boule Noire','Boule Noire'],
    color:'var(--v-boule)', hex:'#F59E32', tone:'halo',
    capacity:200, type:'Intimiste', year:1822,
    street:'120 Boulevard Rochechouart', postal:'75018', city:'Paris',
    lat:48.8821, lon:2.3372,
    metro:'Pigalle · Anvers',
    tagline:"La petite sœur confidentielle de la Cigale.",
    history:"Attenante à la Cigale depuis 1822, la Boule Noire fut d'abord un bal populaire puis un cabaret. Aujourd'hui l'une des plus petites salles de Paris, elle programme des artistes émergents dans un format intime de 200 places, idéal pour les premières parties et les découvertes."
  },
  {
    slug:'bataclan', aliasSlugs:['le-bataclan'], mood:'bataclan', display:'Bataclan', prep:'au ', dbName:'Bataclan',
    names:['Bataclan','Le Bataclan'],
    color:'var(--v-bataclan)', hex:'#D4623F', tone:'warm',
    capacity:1500, type:'Grandes scènes', year:1864,
    street:'50 Boulevard Voltaire', postal:'75011', city:'Paris',
    lat:48.8631, lon:2.3701,
    metro:'Oberkampf · Saint-Ambroise',
    tagline:"Un théâtre chinois devenu salle mythique.",
    history:"Construit en 1864 par l'architecte Charles Duval dans un style chinoisant, le Bataclan fut café-concert, théâtre, puis cinéma. Racheté en 1976 par Jean-Pierre Chaumont, il devient la salle rock que l'on connaît. Rouvert en novembre 2016 après les attentats de 2015, il reste une pièce centrale de la vie nocturne parisienne."
  },
  {
    slug:'la-cigale', aliasSlugs:['cigale'], mood:'cigale', display:'Cigale', prep:'à la ', dbName:'La Cigale',
    names:['La Cigale','Cigale'],
    color:'var(--v-cigale)', hex:'#E87A62', tone:'warm', imgY:'35%',
    capacity:1389, type:'Grandes scènes', year:1887,
    street:'120 Boulevard Rochechouart', postal:'75018', city:'Paris',
    lat:48.8821, lon:2.3371,
    metro:'Pigalle · Anvers',
    tagline:"Music-hall historique au cœur de Pigalle.",
    history:"Ouverte en 1887, la Cigale est classée Monument historique depuis 1991. Restaurée par Philippe Starck en 1987, elle combine balcon en fer à cheval, dorures et acoustique dense. Elle reste une scène de prédilection pour le rock, l'électro et la chanson."
  },
  {
    slug:'cabaret-sauvage', aliasSlugs:['cabaret'], mood:'cabaret', display:'Cabaret Sauvage', prep:'au ', dbName:'Cabaret Sauvage',
    names:['Cabaret Sauvage'],
    color:'var(--v-cabaret)', hex:'#CFB065', tone:'halo',
    capacity:595, type:'Intimiste',  year:1997,
    street:'59 Boulevard Macdonald', postal:'75019', city:'Paris',
    lat:48.8964, lon:2.3697,
    metro:'Porte de la Villette',
    tagline:"Un chapiteau permanent aux accents tziganes.",
    history:"Installé dans le parc de la Villette depuis 1997, le Cabaret Sauvage est un chapiteau rond aux miroirs dorés, mêlant cabaret forain et scène musicale. Il programme musiques du monde, électro et spectacles circassiens dans une ambiance volontairement hors du temps."
  },
  {
    slug:'cafe-de-la-danse', aliasSlugs:['cafedanse'], mood:'cafedanse', display:'Café de la Danse', prep:'au ', dbName:'Café de la Danse',
    names:['Café de la Danse','Cafe de la Danse'],
    color:'var(--v-cafedanse)', hex:'#5E9DB6', tone:'cool',
    capacity:500, type:'Intimiste', year:1989,
    street:'5 Passage Louis-Philippe', postal:'75011', city:'Paris',
    lat:48.8554, lon:2.3673,
    metro:'Bastille',
    tagline:"Une scène discrète derrière la Bastille.",
    history:"Caché dans un passage près de la Bastille, le Café de la Danse ouvre en 1989. Ancienne salle de répétition de danse, son plancher de bois et sa jauge serrée (500 places) en font une scène privilégiée pour la chanson, le folk et l'indie."
  },
  {
    slug:'paris-la-defense-arena', aliasSlugs:['defense','plenitude'], mood:'defense', display:'Plénitude Arena', prep:'à la ', dbName:'Plenitude Arena - Ex Défense Arena',
    names:['Plenitude Arena - Ex Défense Arena','Plénitude Arena','Plenitude Arena','Paris La Défense Arena','Paris La Defense Arena','La Défense Arena'],
    color:'var(--v-defense)', hex:'#9C9AA6', tone:'cool',
    capacity:40000, type:'Stades & Arena', year:2017,
    street:'99 Jardin de l\'Arche', postal:'92000', city:'Nanterre',
    lat:48.8958, lon:2.2297,
    metro:'La Défense · Nanterre-Préfecture',
    tagline:"La plus grande salle couverte d'Europe.",
    history:"Inaugurée en 2017 à Nanterre, la Plénitude Arena (ex-Paris La Défense Arena, renommée en 2026) est une salle modulable de 40 000 places, également stade du Racing 92. Conçue par Christian de Portzamparc, elle a accueilli les Rolling Stones, les Foo Fighters, Rammstein, Taylor Swift et les épreuves de natation des JO de Paris 2024."
  },
  {
    slug:'la-gaite-lyrique', aliasSlugs:['gaite'], mood:'gaite', display:'Gaîté Lyrique', prep:'à la ', dbName:'La Gaîté Lyrique',
    names:['La Gaîté Lyrique','La Gaite Lyrique','Gaîté Lyrique'],
    color:'var(--v-gaite)', hex:'#6B9A7E', tone:'cool',
    capacity:700, type:'Intimiste', year:2011, foundYear:1862,
    street:'3bis Rue Papin', postal:'75003', city:'Paris',
    lat:48.8672, lon:2.3538,
    metro:'Arts et Métiers · République',
    tagline:"Théâtre lyrique reconverti en musiques actuelles.",
    history:"Édifiée en 1862 comme théâtre par Jacques Offenbach, abandonnée pendant vingt ans, la Gaîté Lyrique rouvre en 2011 comme centre culturel dédié aux cultures numériques et aux musiques actuelles. Acoustique pointue, programmation électro, pop et expérimentale."
  },
  {
    slug:'le-zenith', aliasSlugs:['zenith'], mood:'zenith', display:'Zénith', prep:'au ', dbName:'Le Zénith',
    names:['Le Zénith','Le Zenith','Zénith','Zenith'],
    color:'var(--v-zenith)', hex:'#8A9A4F', tone:'warm',
    capacity:6293, type:'Zénith', year:1984,
    street:'211 Avenue Jean Jaurès', postal:'75019', city:'Paris',
    lat:48.8927, lon:2.3931,
    metro:'Porte de Pantin',
    tagline:"La salle modulable du Parc de la Villette.",
    history:"Conçu par Philippe Chaix et Jean-Paul Morel en 1984 pour offrir une alternative moderne à Bercy, le Zénith de Paris a donné son nom à un réseau national de salles. Son architecture légère, couverte de toile, accueille toutes les esthétiques : rock, rap, variété, humour."
  },
  {
    slug:'stade-de-france', aliasSlugs:['stade'], mood:'stade', display:'Stade de France', prep:'au ', dbName:'Stade de France',
    names:['Stade de France'],
    color:'var(--v-stade)', hex:'#9C9AA6', tone:'cool',
    capacity:80000, type:'Stades & Arena', year:1998,
    street:'ZAC du Cornillon Nord', postal:'93216', city:'Saint-Denis',
    lat:48.9245, lon:2.3601,
    metro:'Saint-Denis · La Plaine Stade de France',
    tagline:"Le stade national, 80 000 places.",
    history:"Inauguré pour la Coupe du monde 1998 qu'il a vue se terminer en triomphe, le Stade de France est la plus grande enceinte sportive du pays. En mode concert, il accueille les stades les plus attendus : U2, Coldplay, Beyoncé, Indochine, et plusieurs épreuves des Jeux de Paris 2024."
  },
  {
    slug:'elysee-montmartre', aliasSlugs:['elysee'], mood:'elysee', display:'Élysée Montmartre', prep:"à l'", dbName:'Élysée Montmartre',
    names:['Élysée Montmartre','Elysée Montmartre','Elysee Montmartre'],
    color:'var(--v-elysee)', hex:'#D97757', tone:'warm',
    capacity:1380, type:'Grandes scènes', year:2016, foundYear:1807,
    street:'72 Boulevard Rochechouart', postal:'75018', city:'Paris',
    lat:48.8828, lon:2.3435,
    metro:'Anvers · Pigalle',
    tagline:"Le bal de Montmartre, renaissance 2016.",
    history:"Bal populaire depuis 1807, l'Élysée Montmartre fut peint par Toulouse-Lautrec et vécut tous les régimes politiques français. Gravement endommagé par un incendie en 2011, il a rouvert en 2016 après cinq ans de travaux, conservant son charpente Eiffel d'origine."
  },
  {
    slug:'le-trianon', aliasSlugs:['trianon'], mood:'trianon', display:'Trianon', prep:'au ', dbName:'Le Trianon',
    names:['Le Trianon','Trianon'],
    color:'var(--v-trianon)', hex:'#B96F9A', tone:'warm',
    capacity:1000, type:'Grandes scènes', year:1902,
    street:'80 Boulevard Rochechouart', postal:'75018', city:'Paris',
    lat:48.8824, lon:2.3433,
    metro:'Anvers',
    tagline:"Théâtre à l'italienne entre Pigalle et Anvers.",
    history:"Bâti en 1902 à l'emplacement d'un ancien théâtre, le Trianon conserve son cadre de scène doré, ses balcons et son lustre monumental. Music-hall puis cinéma, il est redevenu salle de concert en 2010 et programme une sélection pointue de rock, pop et chanson."
  },
  {
    slug:'la-maroquinerie', aliasSlugs:['maroquinerie'], mood:'maroquinerie', display:'Maroquinerie', prep:'à la ', dbName:'La Maroquinerie',
    names:['La Maroquinerie','Maroquinerie'],
    color:'var(--v-maroquinerie)', hex:'#C9A44B', tone:'halo', imgY:'18%',
    capacity:500, type:'Intimiste', year:1997,
    street:'23 Rue Boyer', postal:'75020', city:'Paris',
    lat:48.8680, lon:2.3930,
    metro:'Gambetta · Ménilmontant',
    tagline:"Le défricheur indie de Ménilmontant.",
    history:"Ancienne usine de maroquinerie transformée en salle en 1997, la Maroquinerie est devenue le laboratoire indie de l'est parisien. Sa programmation rock, pop et électro a révélé Phoenix, The xx, Christine and the Queens, Fontaines D.C. et beaucoup d'autres."
  },
  {
    slug:'salle-pleyel', aliasSlugs:['pleyel'], mood:'pleyel', display:'Salle Pleyel', prep:'à la ', dbName:'Salle Pleyel',
    names:['Salle Pleyel','Pleyel'],
    color:'var(--v-pleyel)', hex:'#5E9DB6', tone:'cool',
    capacity:1900, type:'Grandes scènes', year:1927,
    street:'252 Rue du Faubourg Saint-Honoré', postal:'75008', city:'Paris',
    lat:48.8770, lon:2.3015,
    metro:'Ternes · Charles de Gaulle–Étoile',
    tagline:"Temple Art Déco du 8ᵉ arrondissement.",
    history:"Inaugurée en 1927 par le pianiste Gustave Lyon, la Salle Pleyel est un joyau Art Déco dédié à la musique classique jusqu'en 2015, année où elle s'est reconvertie aux musiques actuelles. Son acoustique, signée André Dauchez, reste réputée."
  },
  {
    slug:'le-trabendo', aliasSlugs:['trabendo'], mood:'trabendo', display:'Trabendo', prep:'au ', dbName:'Le Trabendo',
    names:['Le Trabendo','Trabendo'],
    color:'var(--v-trabendo)', hex:'#7BA9A6', tone:'cool',
    capacity:700, type:'Intimiste', year:1993,
    street:'211 Avenue Jean Jaurès', postal:'75019', city:'Paris',
    lat:48.8913, lon:2.3925,
    metro:'Porte de Pantin',
    tagline:"Le club moderne du parc de la Villette.",
    history:"Créé en 1993 comme club de jazz, le Trabendo a pris sa forme actuelle en 2002. Proche du Zénith dans le parc de la Villette, il est devenu un passage obligé pour le rock indé, l'électro et le hip-hop, avec une jauge de 700 places qui conserve l'intimité d'un club."
  },
  {
    slug:'accor-arena', aliasSlugs:['accor'], mood:'accor', display:'Accor Arena', prep:"à l'", dbName:'Accor Arena',
    names:['Accor Arena','Bercy','Bercy (AccorArena)','AccorHotels Arena','POPB'],
    color:'var(--v-accor)', hex:'#E8562C', tone:'warm',
    capacity:20300, type:'Stades & Arena', year:1984,
    street:'8 Boulevard de Bercy', postal:'75012', city:'Paris',
    lat:48.8383, lon:2.3785,
    metro:'Bercy',
    tagline:"L'arène historique de l'Est parisien.",
    history:"Inaugurée en 1984 sous le nom de Palais Omnisports de Paris-Bercy, la salle de Bercy (rebaptisée Accor Arena en 2015) est reconnaissable à sa pyramide inversée en gazon. 20 000 places modulables, étape incontournable des tournées stade et lieu de grands événements sportifs."
  },
  {
    slug:'adidas-arena', aliasSlugs:['adidas'], mood:'adidas', display:'Adidas Arena', prep:"à l'", dbName:'Adidas Arena',
    names:['Adidas Arena'],
    color:'var(--v-adidas)', hex:'#E8562C', tone:'warm',
    capacity:7000, type:'Stades & Arena', year:2024,
    street:'40 Avenue du Général Sarrail', postal:'75018', city:'Paris',
    lat:48.9002, lon:2.3601,
    metro:'Porte de la Chapelle',
    tagline:"La nouvelle arène JO 2024.",
    history:"Inaugurée en 2024 pour les épreuves de badminton et de gymnastique rythmique des Jeux de Paris, l'Adidas Arena est devenue la salle de 8 000 places qui manquait au nord de la capitale. Programmation rock, rap, pop et événements sportifs."
  }
];

// Salles « SEO-only » (scrapers/utils/venue_scope.py::PARIS_SEO_ONLY_VENUE_NAMES) :
// elles ont des pages pré-rendues (/salle/, fiches concert, pages artiste) mais ne
// sont listées nulle part. Elles entrent donc dans les tables de correspondance
// (VENUE_BY_SLUG, VENUE_BY_NAME, VENUES_LEGACY), que rien ne parcourt, et JAMAIS
// dans window.VENUES_DATA, que parcourent salles.js, cmdk-search.js,
// design-home.js, stats.js, guides.js et guide-view.js. Miroir de VENUE_META
// (generate_seo_pages.py), vérifié par tests/test_seo_snippets.py. `hidden:true`
// signale aux modules qu'aucun event de la salle n'est dans /data/*.json.
const HIDDEN_VENUES_DATA = [
  {
    slug:'supersonic', mood:'supersonic', display:'Supersonic', prep:'au ', dbName:'Supersonic', hidden:true,
    names:['Supersonic'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:300, type:'Intimiste', year:2016,
    street:'9 Rue Biscornet', postal:'75012', city:'Paris',
    lat:48.8502, lon:2.3697,
    metro:'Bastille (L1, L5, L8)',
    tagline:'',
    history:'Club rock du quartier de la Bastille, ouvert en 2016 dans une ancienne usine de la rue Biscornet, qui programme des concerts indé, souvent gratuits, et des nuits rock.'
  },
  {
    slug:'supersonic-records', mood:'supersonic-records', display:'Supersonic Records', prep:'au ', dbName:'Supersonic Records', hidden:true,
    names:['Supersonic Records'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:180, type:'Intimiste',
    street:'9 Rue Biscornet', postal:'75012', city:'Paris',
    lat:48.8502, lon:2.3697,
    metro:'Bastille (L1, L5, L8)',
    tagline:'',
    history:"Deuxième salle du Supersonic, rue Biscornet (Bastille) : l'ancien disquaire ouvert en 2020 dans une imprimerie des années 1930 est devenu une salle de concert d'environ 180 personnes."
  },
  {
    slug:'popup', mood:'popup', display:'POPUP!', prep:'au ', dbName:'POPUP!', hidden:true,
    names:['POPUP!'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:175, type:'Intimiste',
    street:'14 Rue Abel', postal:'75012', city:'Paris',
    lat:48.8475, lon:2.3756,
    metro:'Gare de Lyon (L1, L14) ou Ledru-Rollin (L8)',
    tagline:'',
    history:"Bar-restaurant avec une salle de concert en sous-sol, rue Abel, entre le marché d'Aligre et la gare de Lyon (anciennement Pop-Up du Label)."
  },
  {
    slug:'petit-bain', mood:'petit-bain', display:'Petit Bain', prep:'au ', dbName:'Petit Bain', hidden:true,
    names:['Petit Bain'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:450, type:'Intimiste',
    street:'7 Port de la Gare', postal:'75013', city:'Paris',
    lat:48.8355, lon:2.3767,
    metro:'Quai de la Gare (L6) ou Bibliothèque François Mitterrand (L14, RER C)',
    tagline:'',
    history:'Équipement culturel flottant amarré port de la Gare, au pied de la Bibliothèque nationale de France : une péniche sur trois niveaux, avec une salle de concert de 450 places debout, un restaurant et un toit-terrasse.'
  },
  {
    slug:'point-ephemere', mood:'point-ephemere', display:'Point Éphémère', prep:'au ', dbName:'Point Éphémère', hidden:true,
    names:['Point Éphémère'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:330, type:'Intimiste',
    street:'200 Quai de Valmy', postal:'75010', city:'Paris',
    lat:48.8814, lon:2.3684,
    metro:'Jaurès (L2, L5, L7bis) ou Louis Blanc (L7, L7bis)',
    tagline:'',
    history:"Lieu culturel du quai de Valmy, au bord du canal Saint-Martin, qui réunit une salle de concert de 330 places, un espace d'exposition, des ateliers d'artistes et des studios de répétition."
  },
  {
    slug:'new-morning', mood:'new-morning', display:'New Morning', prep:'au ', dbName:'New Morning', hidden:true,
    names:['New Morning'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:500, type:'Intimiste', year:1981,
    street:'7-9 Rue des Petites Écuries', postal:'75010', city:'Paris',
    lat:48.8730, lon:2.3534,
    metro:"Château d'Eau (L4) ou Strasbourg-Saint-Denis (L4, L8, L9)",
    tagline:'',
    history:'Club de jazz de la rue des Petites-Écuries, ouvert en 1981, qui programme jazz, blues, soul et musiques du monde dans une salle où le public est très proche des musiciens.'
  },
  {
    slug:'alhambra', mood:'alhambra', display:'Alhambra', prep:"à l'", dbName:'Alhambra', hidden:true,
    names:['Alhambra'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:600, type:'Intimiste', year:2008,
    street:'21 Rue Yves Toudic', postal:'75010', city:'Paris',
    lat:48.8706, lon:2.3631,
    metro:'Jacques Bonsergent (L5) ou République (L3, L5, L8, L9, L11)',
    tagline:'',
    history:'Salle de spectacle de la rue Yves-Toudic, à deux pas de la place de la République, inaugurée en avril 2008, qui programme concerts, humour et spectacles.'
  },
  {
    slug:'badaboum', mood:'badaboum', display:'Badaboum', prep:'au ', dbName:'Badaboum', hidden:true,
    names:['Badaboum'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:400, type:'Intimiste', year:2013,
    street:'2 bis Rue des Taillandiers', postal:'75011', city:'Paris',
    lat:48.8535, lon:2.3758,
    metro:'Ledru-Rollin (L8) ou Bastille (L1, L5, L8)',
    tagline:'',
    history:"Club et salle de concert de la rue des Taillandiers, près de la Bastille, ouvert en 2013 à la place de l'ancienne Scène Bastille, qui alterne concerts et soirées électro."
  },
  {
    slug:'la-bellevilloise', mood:'la-bellevilloise', display:'Bellevilloise', prep:'à la ', dbName:'La Bellevilloise', hidden:true,
    names:['La Bellevilloise'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:0, type:'—',
    street:'19-21 Rue Boyer', postal:'75020', city:'Paris',
    lat:48.8684, lon:2.3922,
    metro:'Ménilmontant (L2) ou Gambetta (L3, L3bis)',
    tagline:'',
    history:'Ancienne coopérative ouvrière fondée en 1877 rue Boyer, devenue un lieu culturel sur plusieurs niveaux (Club, Loft, Forum, Halle aux Oliviers, toit) qui accueille concerts, soirées et expositions.'
  },
  {
    slug:'les-trois-baudets', mood:'les-trois-baudets', display:'Trois Baudets', prep:'aux ', dbName:'Les Trois Baudets', hidden:true,
    names:['Les Trois Baudets'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:200, type:'Intimiste', year:1947,
    street:'64 Boulevard de Clichy', postal:'75018', city:'Paris',
    lat:48.8835, lon:2.3344,
    metro:'Pigalle (L2, L12) ou Blanche (L2)',
    tagline:'',
    history:'Salle du boulevard de Clichy, à Pigalle, créée en 1947 par Jacques Canetti et consacrée à la chanson et aux artistes émergents ; environ 200 places.'
  },
  {
    slug:'le-hasard-ludique', mood:'le-hasard-ludique', display:'Hasard Ludique', prep:'au ', dbName:'Le Hasard Ludique', hidden:true,
    names:['Le Hasard Ludique'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:300, type:'Intimiste',
    street:'128 Avenue de Saint-Ouen', postal:'75018', city:'Paris',
    lat:48.8957, lon:2.3286,
    metro:'Porte de Saint-Ouen (L13) ou Guy Môquet (L13)',
    tagline:'',
    history:"Lieu culturel installé dans une ancienne gare de la Petite Ceinture, avenue de Saint-Ouen, avec une salle de concert d'environ 300 places debout, un restaurant et des ateliers."
  },
  {
    slug:'le-chinois', mood:'le-chinois', display:'Chinois', prep:'au ', dbName:'Le Chinois', hidden:true,
    names:['Le Chinois'],
    color:'#E8562C', hex:'#E8562C', tone:'warm',
    capacity:350, type:'Intimiste', year:2020,
    street:'6 Place du Marché', postal:'93100', city:'Montreuil',
    lat:48.8583, lon:2.4341,
    metro:'Croix de Chavaux (L9)',
    tagline:'',
    history:'Ancien restaurant chinois de la place du Marché, à Montreuil, transformé en 2020 en bar-club et salle de concert, à quelques mètres du métro Croix de Chavaux.'
  }
];

// Build lookups by DB name (all variants) and by slug.
// Canonical slug = long SEO slug. aliasSlugs keeps legacy short URLs routable
// (homepage cards, old deep links) to the same venue via salle.js lookup.
const VENUE_BY_NAME = {};
const VENUE_BY_SLUG = {};
const ALL_VENUES = VENUES_DATA.concat(HIDDEN_VENUES_DATA);
for (const v of ALL_VENUES){
  VENUE_BY_SLUG[v.slug] = v;
  if (Array.isArray(v.aliasSlugs)) for (const a of v.aliasSlugs) VENUE_BY_SLUG[a] = v;
  for (const n of v.names) VENUE_BY_NAME[n] = v;
}

// mood decoupled from slug: slug changed to long SEO canonical, mood stays
// aligned with --mood-* CSS variables in night-bureau.css.
for (const v of ALL_VENUES){ if (!v.mood) v.mood = v.slug; }

// Legacy-shape map for design-home.js (keyed by DB name, shape: slug/prep/display/color/tone/capacity).
const VENUES_LEGACY = {};
for (const v of ALL_VENUES){
  for (const n of v.names){
    VENUES_LEGACY[n] = {slug:v.slug, mood:v.mood, prep:v.prep, display:v.display, color:v.color, tone:v.tone, capacity:v.capacity, imgY:v.imgY||'50%', hex:v.hex};
  }
}

window.VENUES_DATA = VENUES_DATA;
window.VENUE_BY_NAME = VENUE_BY_NAME;
window.VENUE_BY_SLUG = VENUE_BY_SLUG;
window.VENUES_LEGACY = VENUES_LEGACY;

// Image proxy: only hotlink-protected origins go through V1's proxyImage Cloud Function
// (matches ALLOWED_IMG_DOMAINS in functions/index.js). All other venues load directly.
const PROXY_IMG_DOMAINS = ['www.plenitudearena.com', 'plenitudearena.com', 'www.parisladefense-arena.com', 'parisladefense-arena.com', 'www.stadefrance.com', 'stadefrance.com', 'www.artefact.org', 'artefact.org'];
const PROXY_IMG_BASE = 'https://europe-west1-lagenda-1047a.cloudfunctions.net/proxyImage';
window.PROXY_IMG = function(src){
  if (!src) return '';
  if (typeof src !== 'string' || !src.startsWith('https://')) return src || '';
  try {
    const host = new URL(src).hostname;
    // Même encodage que IMG_THUMB : proxyImage n'accepte que cette forme exacte.
    if (PROXY_IMG_DOMAINS.includes(host)) return PROXY_IMG_BASE + '?url=' + encodeURIComponent(src).replace(/'/g, '%27');
  } catch { /* fall through */ }
  return src;
};

// ---------- Miniatures : /api/img?url=…&w=… ----------
// Les visuels viennent des sites des salles, en original : médiane 1 000 px,
// jusqu'à 20 Mo, pour un affichage de 56 à 450 px (/lyon/ défilée en entier :
// 414 Mo d'images). proxyImage les ramène à la largeur demandée, en WebP,
// derrière le CDN de Firebase Hosting (functions/image_proxy.js).
// Largeurs : synchro avec THUMB_WIDTHS (functions/image_proxy.js) et
// scrapers/img_thumbs.py — la page pré-rendue et ce rendu JS doivent écrire
// la MÊME URL, sinon chaque image est téléchargée deux fois.
// L'image OG / JSON-LD / sitemap-images reste l'original : ceci ne sert qu'à l'écran.
const IMG_WIDTHS = [160, 480, 960, 1280];
// row : vignette de liste (56-72 px) · card : carte (330-450 px, 2x en srcset)
// panel : fond de panneau (300-460 px) · hero : bandeau pleine largeur
window.IMG_W = { row: 160, card: 480, panel: 960, hero: 1280 };
window.IMG_THUMB = function(src, w){
  if (!src || typeof src !== 'string' || !src.startsWith('https://')) return window.PROXY_IMG(src);
  const width = IMG_WIDTHS.find(x => x >= w) || IMG_WIDTHS[IMG_WIDTHS.length - 1];
  // %27 : l'URL tient dans un url('…') CSS comme dans un attribut.
  return '/api/img?url=' + encodeURIComponent(src).replace(/'/g, '%27') + '&w=' + width;
};
// srcset « 1x, 2x » ; '' quand il n'y a rien à proposer (pas de miniature).
window.IMG_SRCSET = function(src, w){
  const a = window.IMG_THUMB(src, w), b = window.IMG_THUMB(src, 2 * w);
  return (a === b || !a.startsWith('/api/img?')) ? '' : `${a} 1x, ${b} 2x`;
};
// onerror d'un <img> miniature : la miniature échoue (fonction absente, source
// non redimensionnable, navigateur sans WebP…) -> on retombe sur l'original,
// ou sur data-fallback quand l'original ne se charge pas en direct (hôte
// anti-hotlink : relais historique sans `w`, cf. IMG_FALLBACK) ; ce repli
// échoue à son tour -> on masque, comme avant. Sans « & » ni « " » pour tenir
// tel quel dans un attribut. Même texte : scrapers/img_thumbs.py.
// `window.URL` et pas `URL` : dans un attribut on*, `URL` désigne document.URL
// (une chaîne) — « URL is not a constructor », le repli ne partait jamais.
window.IMG_ONERROR = "var s=this.src,f=this.getAttribute('data-fallback'),u=s.indexOf('/api/img?')<0?'':(f||new window.URL(s).searchParams.get('url'));if(u){this.removeAttribute('srcset');this.src=u}else{this.style.display='none'}";
// Repli d'un hôte anti-hotlink (PROXY_IMG_DOMAINS) : le relais sans `w`.
// '' pour tous les autres hôtes (l'original se charge en direct).
window.IMG_FALLBACK = function(src){
  const p = window.PROXY_IMG(src);
  return (p && p !== src) ? p : '';
};
// Fond CSS en miniature, avec repli sur l'original si elle ne charge pas
// (un background-image n'a pas d'onerror : une image témoin le remplace).
window.IMG_BG_SET = function(el, src, w){
  if (!el || !src) return;
  const t = window.IMG_THUMB(src, w), o = window.PROXY_IMG(src);
  el.style.backgroundImage = `url("${t.replace(/"/g, '%22')}")`;
  if (t === o) return;
  const probe = new Image();
  probe.onerror = () => {
    if ((el.style.backgroundImage || '').includes('/api/img')) el.style.backgroundImage = `url("${o.replace(/"/g, '%22')}")`;
  };
  probe.src = t;
};
// Même repli pour les fonds écrits dans un gabarit HTML : l'élément porte
// data-img-orig (l'original) et un style background-image en miniature.
window.IMG_BG_ATTRS = function(src, w){
  const t = window.IMG_THUMB(src, w);
  return { url: t, orig: window.PROXY_IMG(src) };
};
window.IMG_BG_WIRE = function(root){
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('[data-img-orig]').forEach(el => {
    const o = el.getAttribute('data-img-orig');
    el.removeAttribute('data-img-orig');
    const m = /url\(["']?([^"')]+)["']?\)/.exec(el.style.backgroundImage || '');
    if (!m || !o || m[1] === o || m[1].indexOf('/api/img?') < 0) return;
    const probe = new Image();
    probe.onerror = () => { el.style.backgroundImage = `url("${o.replace(/"/g, '%22')}")`; };
    probe.src = m[1];
  });
};

// ---------- Genre → CSS var (identite photo unifiee) ----------
window.NB_GENRE_VAR = function(genre){
  if (!genre) return 'var(--g-autre)';
  const s = String(genre).toLowerCase();
  if (s.includes('metal')) return 'var(--g-metal)';
  if (s.includes('rock')) return 'var(--g-rock)';
  if (s.includes('rap') || s.includes('hip')) return 'var(--g-rap)';
  if (s.includes('rnb') || s.includes('r&b') || s.includes('r n b')) return 'var(--g-rnb)';
  if (s.includes('electro')) return 'var(--g-electro)';
  if (s.includes('jazz') || s.includes('soul') || s.includes('funk')) return 'var(--g-jazz)';
  if (s.includes('reggae') || s.includes('world')) return 'var(--g-reggae)';
  if (s.includes('classique')) return 'var(--g-classique)';
  if (s.includes('folk') || s.includes('indie')) return 'var(--g-folk)';
  if (s.includes('humour')) return 'var(--g-humour)';
  if (s.includes('spectacle')) return 'var(--g-spectacles)';
  if (s.includes('film') || s.includes('cine') || s.includes('ciné')) return 'var(--g-film)';
  if (s.includes('pop') || s.includes('variet')) return 'var(--g-pop)';
  return 'var(--g-autre)';
};

// ---------- SVG duotone filter — injected once per page ----------
(function injectDuotone(){
  const NS = 'http://www.w3.org/2000/svg';
  function mount(){
    if (document.getElementById('nb-duotone')) return;
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.position = 'absolute';
    svg.style.width = '0';
    svg.style.height = '0';
    svg.style.overflow = 'hidden';
    svg.innerHTML = '<filter id="nb-duotone" color-interpolation-filters="sRGB">' +
      '<feColorMatrix type="matrix" values="0.2126 0.7152 0.0722 0 0  0.2126 0.7152 0.0722 0 0  0.2126 0.7152 0.0722 0 0  0 0 0 1 0"/>' +
      '<feComponentTransfer>' +
        '<feFuncR tableValues="0.039 0.910"/>' +
        '<feFuncG tableValues="0.031 0.337"/>' +
        '<feFuncB tableValues="0.020 0.173"/>' +
      '</feComponentTransfer>' +
      '<feComposite in2="SourceGraphic" operator="arithmetic" k1="0" k2="0.2" k3="0.8" k4="0"/>' +
    '</filter>';
    (document.body || document.documentElement).insertBefore(svg, (document.body || document.documentElement).firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
})();
